const colors = {
  blue: '#004990',
  lightBlue: '#4a8ecc',
  darkBlue: '#19315b',
  red: '#ee3124',
  lightRed: '#f2756d',
  darkRed: '#6e1711',
  green: '#558a49',
  lightGreen: '#8ac871',
  darkGreen: '#2f4a27',
  purple: '#7e488a',
  lightPurple: '#b075b2',
  darkPurple: '#44274a',
  yellow: '#d7a429',
  lightYellow: '#f8ce63',
  darkYellow: '#bc912d',
  grey: '#98a0aa',
  darkGrey: '#3e4044',
  lightGrey: '#ccc',
  black: '#000000',
  white: '#ffffff',
  taupe: '#ede2cc',
  darkTaupe: '#d2cab6',
  coral: '#F2756D',
  lightCoral: '#f2b1b1',
  darkCoral: '#9B4E5B',
};

export default colors;
